import React, { useState, useEffect } from "react";
import Navbar from "../Component/navbar";
import Footer from "../Component/footer.jsx";
import GroupAI1 from "../image/icons/AIres10.svg";
import GroupAI2 from "../image/icons/AIres5.svg";
import GroupAI3 from "../image/icons/AIres2.svg";
import GroupAI4 from "../image/icons/AIres7.svg";
import GroupAI5 from "../image/icons/AIres11.svg";
import GroupAI6 from "../image/icons/AIres3.svg";
import Group1 from "../image/Groupb.svg";
import Group2 from "../image/Groupb1.svg";
import Group3 from "../image/Groupb2.svg";
import Group4 from "../image/Groupb3.png";
import dote1 from "../image/icons/Ellipse 163.svg";
import dote2 from "../image/icons/Ellipse 164.svg";
import dote3 from "../image/icons/Ellipse 165.svg";
import dotes from "../image/icons/dotes.svg";
import rarrow from "../image/icons/rarrow.svg";
import bagor from "../image/icons/bagor.svg";
import dowarrow from "../image/icons/dowarrow.svg";
import ts1 from "../image/icons/ts1.svg";
import ts2 from "../image/icons/ts2.svg";
import ts3 from "../image/icons/ts3.svg";
import cardi1 from "../image/icons/cardi1.svg";
import cardi2 from "../image/icons/cardi2.svg";
import cardi3 from "../image/icons/cardi3.svg";
import cardi4 from "../image/icons/cardi4.svg";
import cardi5 from "../image/icons/cardi5.svg";
// import i6 from '../image/icons/i6.png'
import map from "../image/icons/map.svg";
import mapz from "../image/icons/mapz.svg";
import { connect, useDispatch, useSelector } from "react-redux";
import { refresh } from "../reducer/Actions";
import { Link } from "react-router-dom";
import { API_URL } from "../apiConfig";
import CSRFToken from "../cookies";
import TYPE from "../reducer/Type";

const Home = ({ refresh, isAuthenticated }) => {
  const [linker, setLinker] = useState("");
  const dispatch = useDispatch()

  
  const fetchUserProfile = async () => {
    try {
      const authToken = localStorage.getItem("access");

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      dispatch({
        type: TYPE.GET_USER_SUCCESS,
        payload: {
          user: data,
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if(isAuthenticated){
      fetchUserProfile();
    } 
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      setLinker("/dashboard");
    } else {
      setLinker("/login");
    }
  }, []);
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* <div className="my-4"> */}
        <Navbar />
      {/* </div> */}

      <div class=" sm:px-24 sm:my-10  max-md:max-px-24 max-md:max-py-20 max-md:max-w-full ">
        <div class=" relative px-10 py-10 bg-white  bg-angular-gradient from-orange-50 via-orange-100 to-orange-400 rounded-3xl grid gap-0 sm:grid-cols-2 ">
          <div>
            <div className="flex flex-col pb-14 ">
              <div className="flex flex-col pl-4 mt-16  max-w-[884px] max-md:mt-10 max-md:max-w-full sm:w-full sm:pl:10">
                <div className="flex flex-col max-w-full w-[611px]">
                  <h1 className=" text-6xl font-bold leading-[70px]  text-neutral-800 max-md:max-w-64 max-md:text-3xl max-md:leading-[35px]">
                    Unlock your career potential with an AI-crafted resume.
                  </h1>
                  <p className="mt-3 text-base leading-7 tracking-normal text-black max-md:max-w-64">
                    Craft a standout resume effortlessly with our AI-driven
                    builder and customizable templates. Quick, easy, and
                    professional – get started for free and impress your future
                    employer in minutes!
                  </p>
                </div>

                <div className="z-10 flex flex-col w-full mt-0 text-base leading-6 text-black max-md:pl-1 max-md:mt-0 max-md:max-w-full sm:pl-5">
                  <Link to={linker}>
                    <section className="flex flex-row bg-[#1D6362] text-white  gap-3 w-64 self-start px-3 py-2 my-12 border border-black  rounded-xl    hover:bg-white max-md:px-5 transition-colors duration-1000 ">
                      <p className="my-auto text-xl hover:text-[#1D6362]">
                        Create My Resume
                      </p>
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/12175251441a8750d39c09c28a53936ad1eb679b0fd7bccef50e073f358c3ff6?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                        alt=""
                        className="w-8 shrink-0 aspect-square hover:bg-green"
                      />
                    </section>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className=" absolute z-9 justify-self-end  max-w-full w-[574px] hidden md:block">
            <div className="flex gap-1 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col mt-16 grow max-md:mt-6">
                  <img
                    loading="lazy"
                    src={Group1}
                    alt="Resume1"
                    className="w-full"
                  />
                  <img
                    loading="lazy"
                    src={Group4}
                    alt="Resume2"
                    className="w-full mt-0"
                  />
                </div>
              </div>
              <div className="flex flex-col w-10/12 mb-10 max-md:mb-6 max-md:w-full">
                <div className="flex flex-col mb-16 grow max-md:mb-6">
                  <img
                    loading="lazy"
                    src={Group2}
                    alt="Resume3"
                    className="w-full "
                  />
                  <img
                    loading="lazy"
                    src={Group3}
                    alt="Resume3"
                    className="w-full mt-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-hidden whitespace-nowrap">
          <div className="flex justify-center flex-initial mt-12 animate-marquee sm:mt-24">
            {/* <img src={MaskGroup1} alt="" class=" w-auto h-16 px-28 sm:px-8" />
            <img src={MaskGroup2} alt="" class=" w-auto h-24 px-28 sm:px-8" />
            <img src={MaskGroup3} alt="" class=" w-auto h-16 px-28 sm:px-8" />
            <img src={MaskGroup4} alt="" class=" w-auto h-16 px-28 sm:px-8" /> */}
          </div>
        </div>
      </div>
      <div className="mx-10 my-24 max-md:max-mx-20 max-md:my-24">
        <section className="flex flex-col px-1 max-md:px-5">
          <h1 className="self-center text-5xl font-bold text-center text-black leading-[57.96px] max-md:max-w-full max-md:text-3xl">
            Features designed to help you win your dream job
          </h1>
          <div className="w-full mt-20 max-md:mt-10 max-md:max-w-full">
            <div className="flex gap-10 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col items-center justify-center">
                <img
                  src={GroupAI1}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  Easy Online Resume Builder
                </div>
                <div className="mt-2 text-center">
                  Create an awesome resume in minutes without leaving your web
                  browser
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <img
                  src={GroupAI3}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  Automatic Summary Generator
                </div>
                <div className="mt-2 text-center">
                  Create powerful resume profile in one click. Writers block is
                  no longer an obstacle. Try for free!
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <img
                  src={GroupAI6}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  Your Data Is Safe
                </div>
                <div className="mt-2 text-center">
                  Your data is kept private and protected by strong 256 bit
                  encryption.
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mt-20 max-md:mt-10 max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col items-center justify-center ">
                <img
                  src={GroupAI2}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  Generate Resume With Your Job Title
                </div>
                <div className="mt-2 text-center">
                  Generate your resume in just one click with your current job
                  title and personalise it.
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <img
                  src={GroupAI4}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  AI written phrases
                </div>
                <div className="mt-2 text-center">
                  Use the power of AI and data analysis. Choose generated
                  effective phrases and keywords.
                </div>
              </div>
              <div className="flex flex-col items-center justify-center ">
                <img
                  src={GroupAI5}
                  alt="card"
                  loading="lazy"
                  class=" w-auto h-16 px-28 sm:px-8"
                />
                <div className="mt-4 text-lg font-semibold">
                  Optimize Your Resume
                </div>
                <div className="mt-2 text-center">
                  Formats and designs are optimized for resume filtering
                  algorithms and are ats friendly.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="max-md:max-px-10 max-md:max-mx-20 max-md:max-w-full sm:px-10 sm:mx-20">
        <section>
          <div className="flex gap-0 max-md:flex-col max-md:gap-5 sm:gap-5 sm:">
            <div className="flex flex-col  mt-32  max-w-[884px] max-md:mt-10 max-md:max-w-full sm:w-full sm:pl:10">
              <header className="flex flex-col self-center px-5 my-auto text-black max-md:mt-10 max-md:max-w-full">
                <h1 className=" text-6xl font-bold text-left leading-[70px] text-center text-neutral-800 max-md:max-w-64 max-md:text-3xl max-md:leading-[35px] ">
                  Craft your success in 3 simple steps
                </h1>
                <p className="mt-3 text-base leading-7 tracking-normal text-left text-black max-md:max-w-64 max-md:text-center">
                  Let AI build your resume and choose from our curated
                  templates. Start now! Choose from our handpicked selection of
                  templates to give your resume a professional edge. Success is
                  just two steps away!
                </p>
                <div className="z-10 flex flex-col w-full pl-5 mt-0 ml-2 text-base leading-6 text-black max-md:pl-1 max-md:mt-0 max-md:max-w-full sm:pl-5">
                  <Link to={linker}>
                    <section className="flex self-start w-64 gap-3 px-3 py-2 my-12 text-white transition-colors duration-1000 border border-black bg-slate-700 rounded-xl hover:bg-white max-md:px-5 ">
                      <p className="my-auto text-xl hover:text-[#1D6362]">
                        Create my resume
                      </p>
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a74201ba4b9995e3135082ffa342eda686314d8dcf9e25310a286f8b8f4622f7?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                        alt=""
                        className="w-8 shrink-0 aspect-square"
                      />
                    </section>
                  </Link>
                </div>
              </header>
            </div>
            <div className=" relative  w-[50%] max-md:ml-0 max-md:w-full hidden sm:block">
              <div className=" absolute w-96 mt-10 z-30 bg-white shadow-2xl aspect-[0.86] rounded-[30px] ">
                <div className="flex gap-1 m-4 felx-col">
                  <img src={dote1} alt="" loading="lazy" />
                  <img src={dote2} alt="" loading="lazy" />
                  <img src={dote3} alt="" loading="lazy" />
                </div>
                <hr />
                <div className="m-4 font-semibold">Build my resume</div>
                <div className="flex gap-1 m-4 felx-col">
                  <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                    {" "}
                    <img src={rarrow} alt="" /> Start
                  </div>
                  <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                    <img src={bagor} alt="" /> Build
                  </div>
                  <div className="flex flex-col items-center justify-center w-24 gap-2 p-3 text-xs text-white transition-colors duration-1000 bg-orange-500 border border-gray-500 rounded-md h-28 hover:bg-orange-200">
                    <img src={dowarrow} alt="" /> Downlod
                  </div>
                </div>
                <div className="m-4 font-semibold text-gray-500">
                  Select Templates
                </div>
                <div className="flex gap-3 m-4 felx-col">
                  <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                    {" "}
                    <img src={ts1} alt="" />
                  </div>
                  <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                    <img src={ts2} alt="" />
                  </div>
                  <div className="flex flex-col items-center justify-center gap-2 transition-colors duration-1000 border rounded-md hover:bg-gray-300">
                    <img src={ts3} alt="" />
                  </div>
                </div>
              </div>
              <div className=" absolute  z-0 grow w-96 mt-20 ml-10 bg-gray-900 shadow-2xl aspect-[0.86]  rounded-[30px] "></div>
              <div className="absolute z-10 ml-40 grow w-96">
                {" "}
                <img src={dotes} alt="" />
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="mx-10 my-52 max-md:max-mx-20 max-md:my-16">
        <section className="flex flex-col px-1 max-md:px-5">
          <h1 className="self-center text-6xl font-bold text-center text-black leading-[57.96px] max-md:max-w-full max-md:text-3xl">
            Build, Personalise, and Shine
          </h1>
          <div className="w-full mt-20 max-md:mt-10 max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col items-center justify-center">
                <img src={cardi1} alt="card" loading="lazy" />
                <div className="mt-4 text-lg font-semibold">
                  Select Your Template
                </div>
                <div className="mt-2 text-center">
                  Choose from our range of professionally designed templates
                  tailored for success.
                </div>
              </div>
              <div className="flex flex-col items-center justify-center ">
                <img src={cardi2} alt="card" loading="lazy" />
                <div className="mt-4 text-lg font-semibold">
                  Personalize Your Details
                </div>
                <div className="mt-2 text-center">
                  Easily input your information, skills, and experience with our
                  user-friendly customization tools.
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <img src={cardi3} alt="card" loading="lazy" />
                <div className="mt-4 text-lg font-semibold">
                  Download and Shine
                </div>
                <div className="mt-2 text-center">
                  Download your polished resume instantly and make a lasting
                  impression on employers
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="mx-1 mt-28 max-md:max-mx-20 max-md:max-mt-36 max-md:mx-5">
        <section className="flex flex-col px-1 text-5xl font-bold text-center text-black leading-[78.2px] max-md:text-3xl max-md:px-5">
          <header className="w-full max-md:max-w-full">
            Secure global opportunities with our standout resume
          </header>
          <div className="relative self-center mt-20 w-full aspect-[2] max-w-[1099px] max-md:mt-10 max-md:max-w-full max-md:aspect-[2]">
            <div>
              <img
                loading="lazy"
                src={map}
                alt="Standout resume visual representation"
                className="absolute z-0 self-center w-auto h-auto"
              />
            </div>
            <div>
              <img
                loading="lazy"
                src={mapz}
                alt="Standout resume visual representation"
                className="absolute z-10 w-full h-full mt-8"
              />
            </div>
          </div>
        </section>
      </div>
      <div className="flex gap-5 p-24 mt-24 max-md:flex-col max-md:gap-0 max-md:p-2 max-md:mt-14">
        <section className="flex-col hidden w-6/12 max-md:ml-0 max-md:w-full md:flex">
          {/* <div className=""> */}
          {/* <div className=" absolute w-96 ml-32 z-30 mt-10 bg-white shadow-2xl aspect-[0.86] rounded-[30px]"><img src={cardi4} alt="card Resume" className="object-cover mt-10 ml-8" /></div> */}
          <div className="flex flex-col ml-32 z-30 mt-10 px-6 py-5 bg-white rounded-3xl shadow-lg max-w-[365px]">
            <img
              loading="lazy"
              src={cardi4}
              alt="card Resume"
              className="w-full aspect-[0.96]"
            />
          </div>
          <div className=" absolute  z-0 grow w-96 mt-20 ml-20 bg-gray-900 shadow-2xl aspect-[0.86]  rounded-[30px]"></div>
          <div className="absolute z-10 ml-14 mt-72 grow w-96">
            {" "}
            <img src={cardi5} alt="" />
          </div>
          {/* </div> */}
        </section>
        <section className="flex flex-col w-6/12 ml-5 max-md:ml-0 max-md:w-full ">
          <article className="flex flex-col px-1 mt-12 text-black max-md:mt-10 max-md:max-w-full max-md:px-1">
            <h1 className=" text-6xl font-bold text-left  leading-[70px]  text-neutral-800 max-md:max-w-fit max-md:text-3xl max-md:leading-[35px] max-md:text-center">
              Impressive & HR-Approved templates to land your dream job <br />
            </h1>
            <p className="mt-3 text-base leading-7 tracking-normal text-left text-black max-md:max-w-fit max-md:text-center">
              Discover Your Path to Success: Elevate Your Resume with Our
              HR-Approved Templates and Secure Your Dream Job!
            </p>
            <div className="z-10 flex flex-col w-full pl-5 mt-0 ml-2 text-base leading-6 text-black max-md:pl-1 max-md:mt-0 max-md:max-w-full max-md sm:pl-5">
              <Link to={linker}>
                <section className="flex w-64 gap-3 px-3 py-2 my-12 text-left text-white transition-colors duration-1000 border border-black bg-slate-700 rounded-xl hover:bg-white max-md:px-5 max-md:text-center max-md:mx-auto max-md:my-6 max-md:justify-center">
                  <p className="my-auto text-xl hover:text-[#1D6362]">
                    Create my resume
                  </p>
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/a74201ba4b9995e3135082ffa342eda686314d8dcf9e25310a286f8b8f4622f7?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                    alt=""
                    className="w-8 shrink-0 aspect-square"
                  />
                </section>
              </Link>
            </div>
          </article>
        </section>
      </div>

      {/* <div className="mt-40 ">
        <div className="flex flex-row mx-40 "> 
          <div className="relative flex-1">
            <div className="absolute z-10 bg-zinc-800 h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
            <img src={i1} alt="" className="z-20 absolute w-full aspect-square max-w-[105px]" />
            <div className="absolute z-0 mt-10 mx-16 px-10 pt-7 bg-white shadow-md rounded-3xl max-w-[413px] min-h-[126px] ">
              <h2><b>Sirushti</b></h2>
              <p><i>Thanks to Resumebeen, I landed my dream job with their stellar templates! Game-changer!</i></p>
            </div>
          </div>
          <div className="relative flex-1 mt-4 ml-20 float-end">
            <div className="z-0 mt-10 m2-16 pl-10 pt-7 bg-white shadow-md rounded-3xl max-w-[413px] min-h-[126px] ">
              <div className="relative z-10 bg-teal-800 float-end mt-[-80px] mr-[-55px] h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
              <img src={i2} alt="" className="z-20 relative float-end mt-[-75px] mr-[-60px] w-full aspect-square max-w-[105px]" />
              <h2><b>Ankit Sreenvasa</b></h2>
              <p><i>Impressive templates and easy customization - Resumebeen made my job search a breeze!</i></p>
            </div>
          </div>
        </div>
        <div className="flex flex-row mx-64 mt-[-450px] d2">
          <div className="relative flex-1">
            <div className="absolute z-10 bg-amber-300 mt-16 h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
            <img src={i5} alt="" className="z-20 absolute w-full aspect-square max-w-[105px]" />
          </div>
          <div className="mt-20 text-4xl font-bold">Success Stories</div>
          <div className="relative flex-1 float-end ">
            <div className="z-0 mt-10  pt-10 ml-[-150px] max-w-[413px] min-h-[126px] shadow-[3px_4px_24px_rgba(202,227,231,0.2)]">
              <div className="relative z-10 bg-orange-500 float-end mt-[-15px] mr-[-65px] h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
              <img src={i5} alt="" className="z-20 relative float-end mt-[-75px] mr-[-60px] w-full aspect-square max-w-[105px]" />
            </div>
          </div>
        </div>
        <div className="flex flex-row mx-40 mt-[-500px]">  
          <div className="relative flex-1">
            <div className="absolute z-10 bg-amber-300 mt-16 h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
            <img src={i3} alt="" className="z-20 absolute w-full aspect-square max-w-[105px]" />
            <div className="absolute z-0 mt-10 mx-16 px-10 pt-6 bg-white shadow-md rounded-3xl max-w-[413px] min-h-[126px]">
              <h2><b>Alex</b></h2>
              <p><i>Kudos to Resumebeen! Their templates helped me secure a job that aligns perfectly </i></p>
            </div>
          </div>
          <div className="relative flex-1 mt-4 ml-20 float-end">
            <div className="z-0 mt-10 m2-16 pl-10 pt-6 bg-white shadow-md rounded-3xl max-w-[413px] min-h-[126px]">
              <div className="relative z-10 bg-orange-500 float-end mt-[-15px] mr-[-65px] h-[53px] min-h-[53px] rounded-[40px] w-[53px]" tabIndex="0" role="region" aria-label="Round Zinc Section"></div>
              <img src={i4} alt="" className="z-20 relative float-end mt-[-75px] mr-[-60px] w-full aspect-square max-w-[105px]" />
              <h2><b>Ankit Sreenvasa</b></h2>
              <p><i>Built my standout resume effortlessly with Resumebeen. It's a must-try for job seekers!</i></p>
            </div>
          </div>
        </div>
      </div> */}
      <section className="flex items-center justify-center px-16 py-20 text-center mt-52 bg-stone-950 max-md:px-5 max-md:py-10 max-md:mt-32">
        <div className="flex flex-col my-12 max-w-full w-[798px] max-md:mt-10 max-md:my-6">
          <h1 className="text-5xl font-bold text-white shadow-2xl leading-[65px] max-md:max-w-full max-md:text-2xl max-md:leading-[35px]">
            Try Resumebeen's professional <br /> resume builder now. Start for
            free!
          </h1>
          <form className="flex gap-0 justify-between self-center h-fit py-2.5 pr-3.5 pl-8 mt-24 max-w-full text-base tracking-normal leading-7 bg-white rounded-3xl shadow-2xl w-[633px] max-md:flex-wrap max-md:pl-5 max-md:mt-10 max-md:py-2 max-md:gap-5 max-my[300x]">
            <label htmlFor="emailInput" className="sr-only">
              Your email
            </label>
            <input
              type="email"
              id="emailInput"
              className="flex-1 block px-1 py-0 text-xl font-bold text-orange-500 w-28 h-fit focus:outline-none max-md:w-full max-md:mb-4 max-md:px-3 max-md:py-2 "
              placeholder="Your email"
              aria-label="Your email"
            />
            <button
              type="submit"
              className="justify-center flex-none px-8 py-1 text-white bg-orange-500 h-fit rounded-xl max-md:px-2 max-md:w-24 max-md:text-xs "
            >
              Start Building
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  refresh: () => dispatch(refresh()),
});

export default connect(null, mapDispatchToProps)(Home);
